/* eslint-disable eqeqeq */
import React, { createContext, useState } from 'react';
import tdApi from '../api/tdApi';
import { useLocation } from "react-router-dom";
import queryString from 'query-string';

export const BrujoContext = createContext( {});

export const BrujoProvider = ({children}) => {

  const location = useLocation();

  const { cultural = '',
          material = '',
          periodo = '',
          objeto = '',
          prov = ''
        } = queryString.parse( location.search );

  const [periodos, setPeriodos] = useState([]);
  const [tipoObjetos, setTipoObjetos] = useState([]);
  const [proveniencias, setProveniencias] = useState([]);
  const [materiales, setMateriales] = useState([]);
  const [culturas, setCulturas] = useState([]);  

  const loadPeriodos = async() => {
    const resp = await tdApi.get('/getperiodo');
    
    setPeriodos(resp.data);

    return resp.data;
  };

  const loadTipoObjeto = async() => {
    const resp = await tdApi.get('/gettipoobjeto');
    
    setTipoObjetos(resp.data);

    return resp.data;
  };

  const loadProveniencias = async() => {
    const resp = await tdApi.get('/getproveniencia');
    
    setProveniencias(resp.data);

    return resp.data;
  };

  const loadMateriales = async() => {
    const resp = await tdApi.get('/getmaterial');
    
    setMateriales(resp.data);

    return resp.data;
  };

  const loadCulturas = async() => {
    const resp = await tdApi.get('/getcultura');
    
    setCulturas(resp.data);

    return resp.data;
  };

  const apiSearchTermino = async(termino, codigomuseo, filiacion_cultural_id, tipo_material_id, periodo_id, tipo_objeto_id, proveniencia_codigo) => {
    const resp = await tdApi.post('/search', {
      termino,
      codigomuseo,
      filiacion_cultural_id,
      tipo_material_id,
      periodo_id,
      tipo_objeto_id,
      proveniencia_codigo
    });
    
    return resp.data;
  };

  const searchAutocomplete = async(value) => {
    const resp = await tdApi.get(`/autocomplete/${value}`);
    
    return resp.data;
  };

  const searchPiezaId = async(value) => {
    const resp = await tdApi.get(`/getpieza/${value}`);
    
    return resp.data;
  };

  const findItemLocation = async(tipo) => {
    if (tipo === 'tcultura' && cultural !== '') {
      const loadData = await loadCulturas();
      const response = loadData.find(element => element.cul_id == cultural)
      return response.cul_name
    }
    else if (tipo === 'tmaterial' && material !== '') {
      const loadData = await loadMateriales();
      const response = loadData.find(element => element.mat_id == material)
      return response.mat_name
    }
    else if (tipo === 'tperiodo' && periodo !== '') {
      const loadData = await loadPeriodos();
      const response = loadData.find(element => element.per_id == periodo)
      return response.per_name
    }
    else if (tipo === 'tobjeto' && objeto !== '') {
      const loadData = await loadTipoObjeto();
      const response = loadData.find(element => element.tob_id == objeto)
      return response.tob_name
    }
    else if (tipo === 'tproveniencia' && prov !== '') {
      const loadData = await loadProveniencias();
      const response = loadData.find(element => element.provenienciaCodigo == prov)
      return response.provenienciaNombre
    } else {
      return '';
    }
  }

  return (
    <BrujoContext.Provider value={{
      periodos,
      tipoObjetos,
      proveniencias,
      materiales,
      culturas,
      loadPeriodos,
      loadTipoObjeto,
      loadProveniencias,
      loadMateriales,
      loadCulturas,
      apiSearchTermino,
      searchPiezaId,
      searchAutocomplete,
      findItemLocation
    }}>
      { children }
    </BrujoContext.Provider>
  );
};
